export interface GlobalState {
  backendIdentifier?: string;
  notifications: null | {
    id: string,
    notification: string,
    type: 'info' | 'error'
  }[];
  visibilities: {
    menu: null | boolean,
    notifications: boolean
  }
}

export const initialGlobalState = (): GlobalState => {
  return {
    notifications: null,
    visibilities: {
      menu: null,
      notifications: false
    }
  };
};
